import React from 'react';
import styled from 'styled-components';
import { ColumnsType } from 'antd/lib/table';
import { getI18n } from 'react-i18next';
import TableHeader from '~/pages/agent/components/agent/tableElements/TableHeader';
import { CircleIcon } from '~/img';
import colors from '~/constants/colors';
import { AgentLead } from '~/types/AgentLead';
import { AgentApplication } from '~/types/AgentApplication';
import { CellText } from '~/pages/agent/components/agent/tableElements/cells/CellText';
import direction from '~/utils/direction';

function statusCell(): ColumnsType<any>[0] {
  return {
    title: () => (
      <TableHeader title={getI18n().t('Status', { ns: 'agent' })} sortingDataKey="status" />
    ),
    dataIndex: 'statusKey',
    render: (status, record: AgentLead | AgentApplication) => {
      const isAutoFail = record?.status === 'Automated Onboarding Failure';
      const displayText = isAutoFail ? 'Automated Onboarding' : record?.status;
      const dotColor = isAutoFail ? colors.agentStatusGreen : statusColor(status);
      return (
        <Container dir={getI18n().dir()}>
          <CircleIcon style={{ color: dotColor }} />
          <CellText className="agentTableStatus">{displayText}</CellText>
        </Container>
      );
    },
    width: 160,
  };
}

export const statusColor = (status: AgentLead['statusKey'] | AgentApplication['statusKey']) => {
  switch (status) {
    case 'NEW':
      return colors.agentStatusOrange;
    case 'fillingData':
    case 'onReview':
    case 'CONTACTED':
    case 'contract':
    case 'payment':
    case 'services':
      return colors.agentStatusBlue;
    case 'CONVERTED':
      return colors.agentStatusPurple;
    case 'completed':
    case 'manualOnboarding':
    case 'automatedOnboarding':
      return colors.agentStatusGreen;
    case 'terminated':
    case 'rejected':
    case 'screeningFailed':
    case 'screening':
    case 'TERMINATED':
    default:
      return colors.agentStatusDark;
  }
};

const Container = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;

  .agentTableStatus {
    ${direction.margin.left(5)};
  }
`;

export default statusCell;
